import { EMPTY_OBJECT } from '../../../constants/common'
import { PressAction } from '../../Action'
import { NavArrowButton } from '../NavArrowButton'
import { NavArrowsControl } from '../NavArrowsControl'

import {
  NAV_ARROWS_NEXT_BUTTON_DIRECTION,
  NAV_ARROWS_PREV_BUTTON_DIRECTION,
  NAV_ARROWS_SIZE,
} from './NavArrows.constants'

import * as styles from './NavArrows.module.css'

function NavArrows({
  Component = 'div',
  NextAction = PressAction,
  PrevAction = PressAction,
  className = styles.NavArrows,
  nextActionProps: {
    Component: NextActionComponent = NavArrowButton,
    className: nextActionClassName = styles.nextAction,
    direction: nextActionDirection = NAV_ARROWS_NEXT_BUTTON_DIRECTION,
    ...nextActionProps
  } = EMPTY_OBJECT,
  prevActionProps: {
    Component: PrevActionComponent = NavArrowButton,
    className: prevActionClassName = styles.prevAction,
    direction: prevActionDirection = NAV_ARROWS_PREV_BUTTON_DIRECTION,
    ...prevActionProps
  } = EMPTY_OBJECT,
  size = NAV_ARROWS_SIZE,
  ...controlProps
}) {
  return (
    <NavArrowsControl
      {...controlProps}
      Component={Component}
      NextAction={NextAction}
      PrevAction={PrevAction}
      className={className}
      nextActionProps={{
        ...nextActionProps,
        Component: NextActionComponent,
        className: nextActionClassName,
        direction: nextActionDirection,
        size,
      }}
      prevActionProps={{
        ...prevActionProps,
        Component: PrevActionComponent,
        className: prevActionClassName,
        direction: prevActionDirection,
        size,
      }}
    />
  )
}

export default NavArrows
